import { useState, useRef, useEffect } from "react";
import { BoldifyReplace } from "./BoldifyReplace";
import { exportHomebrewActions } from '../../constants';

const EditStatOptionsSelect = ({label, creatureValues, options = exportHomebrewActions, cKey, handleChange }) => {
    const [open, setOpen] = useState(false);
    const [values, setValues] = useState(creatureValues.split(/[;,]+/).map(v => v.trim()).filter(str => str.trim() !== "") || [])
    const [changeMade, setChangeMade] = useState(false)
    const dropdownRef = useRef(null);

    const handleSetValues = (option) => {

        // semicolons is for damage immunities
        let searchValues = values.map(v => v.toLowerCase().trim().replace(';', ''))
        option = option.toLowerCase().trim().replace(';', '')

        setChangeMade(true)
        // Remove the option if already selected
        searchValues.includes(option.trim())
            ? setValues([...searchValues.filter(v => v !== option)])
            : setValues([option, ...searchValues]);
    };

    useEffect(() => {
        // Save the changes 
        if(!open && changeMade) {
            let sendValues = values;
            // Sort into the same order as the options
            sendValues = options
                .map(opt => opt.toLowerCase())
                .filter(opt => values.map(v => v.toLowerCase()).includes(opt));

            // Look for different type of damage in immunities
            if(label === 'Immunities') {
                const foundIndex = sendValues.findIndex(str => str.includes("pierc") || str.includes("slash") || str.includes("bludge"));
                if(foundIndex > 0) {
                    sendValues[foundIndex-1] = sendValues[foundIndex-1] + ";"
                }
            }
            // set the sorted local values
            setValues(sendValues)

            // send the change up to parent creature
            let e = {target: {value: sendValues.join(', ').replace(';,', ';')}}
            handleChange(e, cKey, undefined, undefined, true)
            setChangeMade(false)
        }
    }, [open]);

    // Close dropdown if clicked outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className="editBlock" ref={dropdownRef}>
            <b>{label && <>{label}</>}</b>

            <div className="editOptionsBlockValuesContainer" style={open ? {backgroundColor: "#dcd9d0", border: "1px solid #919191"} : {}} onClick={() => setOpen(o => !o)}>
                <div className="editOptionBlockValues">
                    {label === 'Condition Immunities' ? 
                        <>
                            {values.length > 0 && <BoldifyReplace desc={values.map((c) => {return `{@condition ${c}}`}).join(', ')} />}
                        </>
                    : 
                        values.join(', ').replace(';,', ';')
                    }
                </div>
                <svg width="16" height="16" viewBox="0 0 16 16" style={{
                    verticalAlign: "middle",
                    transition: "transform 0.2s",
                    transform: open ? "rotate(0deg)" : "rotate(90deg)",
                    minWidth: "16px",
                    minHeight: "16px"
                }}>
                    <polyline points="4,6 8,10 12,6" fill="none" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </div>
            
            {open && (
                <div className="editOptionsListContainer" style={{ minWidth: "150px"}}>
                    <ul className="searchOptionCheckboxList">
                        {options.map((option) => (
                            <label key={option+'label'} style={{ cursor: "pointer" }}>
                                <li key={option+'li'} className="searchOptionCheckboxListItem">
                                    <input
                                        className="searchOptionCheckbox"
                                        type="checkbox"
                                        checked={values.some(selectedValue => {
                                            selectedValue = selectedValue.toLowerCase().replace(';', '')
                                            return option.toLowerCase() === selectedValue;
                                        })}
                                        onChange={() => handleSetValues(option)}
                                    />
                                    {option}
                                </li>
                            </label>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default EditStatOptionsSelect;